// NGRX
import {Store, select} from '@ngrx/store';
// CRUD
import {BaseDataSource, QueryResultsModel} from '../../_base/crud';
// State
import {AppState} from '../../reducers';
// Selectirs
import {selectSubTypeCategoryQueryResult, selectSubTypeCategorysPageLoading, selectSubTypeCategorysShowInitWaitingMessage} from '../_selectors/sub-type-category.selectors';

export class SubTypeCategorysDataSource extends BaseDataSource {
    trashed: number = 0;

    constructor(private store: Store<AppState>) {
        super();

        this.loading$ = this.store.pipe(
            select(selectSubTypeCategorysPageLoading)
        );

        this.isPreloadTextViewed$ = this.store.pipe(
            select(selectSubTypeCategorysShowInitWaitingMessage)
        );

        this.store.pipe(
            select(selectSubTypeCategoryQueryResult)
        ).subscribe((response: QueryResultsModel) => {
            this.paginatorTotalSubject.next(response.totalCount);
            this.entitySubject.next(response.items);
        });

    }
}
